import {getSissiEncoreUrl} from "../../config/server";

const BASE = () => `${getSissiEncoreUrl()}/provinces`;

async function parseError(response) {
  try {
    const body = await response.json();
    return body.message || response.statusText;
  } catch (_e) {
    return response.statusText;
  }
}

async function getProvinces(params = {}) {
  const query = {
    ...params,
    q: params.name || params.filter,
    skip: params.skip || 0,
    limit: params.limit || 50,
  };
  if (!query.q) delete query.q;
  if (query.countryId === undefined || query.countryId === null) delete query.countryId;
  delete query.filter;
  delete query.name;

  const url = new URL(BASE());
  url.search = new URLSearchParams(query).toString();

  const res = await fetch(decodeURIComponent(url.toString()), {
    credentials: 'include',
    mode: 'cors',
  });
  if (res.status !== 200) {
    throw new Error(await parseError(res));
  }
  return res.json();
}

async function getProvince(id) {
  const res = await fetch(`${BASE()}/${id}`, {credentials: 'include', mode: 'cors'});
  if (res.status === 404) return null;
  if (res.status !== 200) {
    throw new Error(await parseError(res));
  }
  return res.json();
}

async function saveProvince(province) {
  const res = await fetch(BASE(), {
    method: 'POST',
    credentials: 'include',
    mode: 'cors',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(province),
  });
  if (!res.ok) {
    throw new Error(await parseError(res));
  }
  return res.json();
}

async function updateProvince(id, province) {
  const res = await fetch(`${BASE()}/${id}`, {
    method: 'PUT',
    credentials: 'include',
    mode: 'cors',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(province),
  });
  if (!res.ok) {
    throw new Error(await parseError(res));
  }
  return res.json();
}

async function deleteProvince(province) {
  const id = typeof province === 'object' ? province.id : province;
  const res = await fetch(`${BASE()}/${id}`, {
    method: 'DELETE',
    credentials: 'include',
    mode: 'cors',
  });
  if (!res.ok) {
    throw new Error(await parseError(res));
  }
  const body = await res.json();
  return !!body.success;
}

async function getCountriesForSelect() {
  const url = new URL(`${getSissiEncoreUrl()}/countries`);
  url.search = new URLSearchParams({limit: 500, skip: 0}).toString();
  const res = await fetch(decodeURIComponent(url.toString()), {
    credentials: 'include',
    mode: 'cors',
  });
  if (res.status !== 200) return {data: []};
  return res.json();
}

export {getProvinces, getProvince, saveProvince, updateProvince, deleteProvince, getCountriesForSelect};
